<template>
  <div>
    <div class="d-flex justify-space-between">
      <div>
        <span class="qtm-label" :class="`text-${color}`">
          <slot name="label">
            {{ label }}
          </slot>
          <span v-if="required" class="text-primary">
            *
          </span>
        </span>
        <v-tooltip v-if="info" location="top" max-width="314" :text="info">
          <template v-slot:activator="{ props: tooltipProps }">
            <v-icon v-bind="tooltipProps" color="interactive">
              mdi-information-outline
            </v-icon>
          </template>
        </v-tooltip>
        <slot name="label-append" />
      </div>
      <slot name="append" />
    </div>
    <slot />
  </div>
</template>

<script setup lang="ts">
export interface Props {
  color?: string
  info?: string
  label?: string
  required?: boolean
}

withDefaults(defineProps<Props>(), {
  color: 'secondary',
  info: undefined,
  label: '',
})
</script>
